module.exports = __webpack_public_path__ + "img/leve-seu-entretenimento-com-voce.436b3916.png";